import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import { useTranslation } from 'react-i18next';

const CompanyNav = ({ onTabChange }) => {
     const [activeTab, setActiveTab] = useState('profile');
     const { t } = useTranslation();

     const handleTabSelect = (selectedTab) => {
          setActiveTab(selectedTab);
          onTabChange(selectedTab);
     };

     return (
          <Nav variant="tabs" defaultActiveKey="profile" onSelect={handleTabSelect}>
               <Nav.Item>
                    <Nav.Link eventKey="profile" active={activeTab === 'profile'} className="nav-link">
                         {t('profile')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="bank" active={activeTab === 'bank'} className="nav-link">
                         {t('bank')}
                    </Nav.Link>
               </Nav.Item>
               <Nav.Item>
                    <Nav.Link eventKey="logo" active={activeTab === 'logo'} className="nav-link">
                         {t('logo')}
                    </Nav.Link>
               </Nav.Item>
          </Nav>
     );
};

export default CompanyNav;
